import { alpha } from '@mui/system'
import globalTheme, { muiTheme } from '../global'

const Button = {
	MuiButton: {
		styleOverrides: {
			root: {
				fontFamily: globalTheme.typography.button.fontFamily,
				fontSize: globalTheme.typography.button.fontSize,
				lineHeight: globalTheme.typography.button.lineHeight,
				padding: '19px 40px',
				minWidth: 159,
				textTransform: 'none',
				boxShadow: 'none',
				borderRadius: globalTheme.shape.borderRadius,
				border: '2px solid transparent',
				//color: globalTheme.palette.primary.main,
				'& .MuiButton-startIcon': {
					marginLeft: 0,
					marginRight: globalTheme.spacing(2),
					'&>*:nth-of-type(1)': {
						fontSize: muiTheme.typography.pxToRem(16),
					},
				},
				'& .MuiButton-endIcon': {
					marginLeft: globalTheme.spacing(2),
					marginRight: 0,
				},
			},
			containedPrimary: {
				color: globalTheme.palette.primary.contrastText,
				minHeight: 60,
				'&:hover': {
					boxShadow: 'none',
					backgroundColor: alpha(globalTheme.palette.primary.main, '0.85'),
				},
				'&:focus': {
					boxShadow: 'none',
					backgroundColor: alpha(globalTheme.palette.primary.main, '0.9'),
				},
				'&:active': {
					boxShadow: 'none',
					backgroundColor: alpha(globalTheme.palette.primary.main, '0.7'),
				},
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.medium,
					opacity: 0.9,
					backgroundColor: alpha(globalTheme.palette.primary.main, '0.1'),
					'& .MuiButton-startIcon': {
						fill: globalTheme.palette.grey.medium,
					},
					'& .MuiButton-endIcon': {
						fill: globalTheme.palette.grey.medium,
					},
				},
				'& .MuiButton-startIcon': {
					fill: globalTheme.palette.primary.contrastText,
				},
				'& >svg': {
					color: globalTheme.palette.primary.contrastText,
				},
				'& .MuiButton-endIcon': {
					fill: globalTheme.palette.primary.contrastText,
				},
				'& .MuiCircularProgress-root': {
					color: globalTheme.palette.primary.contrastText,
				},
			},
			containedSecondary: {
				color: globalTheme.palette.secondary.contrastText,
				minHeight: 60,
				'&:hover': {
					boxShadow: 'none',
					backgroundColor: alpha(globalTheme.palette.secondary.main, '0.85'),
				},
				'&:focus': {
					boxShadow: 'none',
					backgroundColor: globalTheme.palette.secondary.main,
				},
				'&:active': {
					boxShadow: 'none',
					backgroundColor: globalTheme.palette.secondary.dark,
				},
				'&.Mui-disabled': {
					color: globalTheme.palette.secondary.contrastText,
					backgroundColor: alpha(globalTheme.palette.secondary.main, '0.2'),
				},
				'& .MuiButton-startIcon': {
					fill: globalTheme.palette.secondary.contrastText,
				},
				'& >svg': {
					color: globalTheme.palette.secondary.contrastText,
				},
				'& .MuiButton-endIcon': {
					fill: globalTheme.palette.secondary.contrastText,
				},
			},
			outlined: {
				borderRadius: '4px',
				borderWidth: '2px',
				padding: '19px 40px',
				minHeight: 60,
				'&:hover': {
					borderWidth: '2px',
				},
				'&:focus': {
					borderWidth: '2px',
				},
				'&:active': {
					borderWidth: '2px',
				},
				'&.Mui-disabled': {
					borderWidth: '2px',
				},
			},
			outlinedPrimary: {
				borderColor: globalTheme.palette.grey.light,
				'&:hover': {
					backgroundColor: globalTheme.palette.primary.main,
					borderColor: globalTheme.palette.primary.main,
					color: globalTheme.palette.primary.contrastText,
					'& .MuiButton-startIcon': {
						fill: globalTheme.palette.primary.contrastText,
						'.MuiSvgIcon-root': {
							color: globalTheme.palette.primary.contrastText,
						},
					},
					'& .MuiButton-endIcon': {
						fill: globalTheme.palette.primary.contrastText,
					},
				},
				'&:focus': {
					backgroundColor: alpha(globalTheme.palette.primary.main, '0.85'),
					borderColor: alpha(globalTheme.palette.primary.main, '0'),
					color: globalTheme.palette.primary.contrastText,
				},
				'&:active': {
					backgroundColor: alpha(globalTheme.palette.primary.main, '0.93'),
					borderColor: alpha(globalTheme.palette.primary.main, '0.93'),
					color: globalTheme.palette.primary.contrastText,
				},
				'&.Mui-disabled': {
					borderColor: globalTheme.palette.grey.light,
					color: globalTheme.palette.grey.medium,
					backgroundColor: globalTheme.palette.grey.disabled,
				},
				'& .MuiButton-startIcon': {
					fill: globalTheme.palette.primary.main,
				},
				'& .MuiButton-endIcon': {
					fill: globalTheme.palette.primary.main,
				},
			},
			outlinedSecondary: {
				borderColor: globalTheme.palette.secondary.light,
				'&:hover': {
					backgroundColor: globalTheme.palette.secondary.main,
					borderColor: globalTheme.palette.secondary.main,
					color: globalTheme.palette.secondary.contrastText,
					'& .MuiButton-startIcon': {
						fill: globalTheme.palette.secondary.contrastText,
					},
					'& .MuiButton-endIcon': {
						fill: globalTheme.palette.secondary.contrastText,
					},
				},
				'&:focus': {
					backgroundColor: alpha(globalTheme.palette.secondary.main, '0.85'),
					borderColor: alpha(globalTheme.palette.secondary.main, '0'),
					color: globalTheme.palette.secondary.contrastText,
				},
				'&:active': {
					backgroundColor: alpha(globalTheme.palette.secondary.main, '0.93'),
					borderColor: alpha(globalTheme.palette.secondary.main, '0.93'),
					color: globalTheme.palette.secondary.contrastText,
				},
				'&.Mui-disabled': {
					borderColor: globalTheme.palette.grey.light,
					color: globalTheme.palette.grey.medium,
					backgroundColor: globalTheme.palette.grey.disabled,
				},
				'& .MuiButton-startIcon': {
					fill: globalTheme.palette.secondary.main,
				},
				'& .MuiButton-endIcon': {
					fill: globalTheme.palette.secondary.main,
				},
			},
			outlinedWhite: {
				borderColor: globalTheme.palette.common.white,
				color: globalTheme.palette.common.white,
				'&:hover': {
					backgroundColor: globalTheme.palette.common.white,
					color: globalTheme.palette.common.black,
				},
			},
			ghost: {
				backgroundColor: 'transparent',
				border: '2px solid',
				borderColor: 'transparent',
				padding: '19px 40px',
				minHeight: 60,
				'&:hover': {
					border: '2px solid',
					backgroundColor: globalTheme.palette.ghost.hover,
					borderColor: 'transparent',
				},
				'&:focus': {
					border: '2px solid',
					backgroundColor: globalTheme.palette.common.white,
					borderColor: globalTheme.palette.grey.light,
				},
				'&:active': {
					border: '2px solid',
					backgroundColor: globalTheme.palette.grey.active,
					borderColor: globalTheme.palette.grey.active,
				},
				'&.Mui-disabled': {
					border: '2px solid',
					borderColor: globalTheme.palette.grey.light,
					color: globalTheme.palette.grey.medium,
					backgroundColor: globalTheme.palette.grey.disabled,
					'& .MuiButton-startIcon': {
						fill: globalTheme.palette.grey.medium,
					},
					'& .MuiButton-endIcon': {
						fill: globalTheme.palette.grey.medium,
					},
				},
				'& .MuiButton-startIcon': {
					fill: globalTheme.palette.primary.main,
				},
				'& .MuiButton-endIcon': {
					fill: globalTheme.palette.primary.main,
				},
			},
			text: {
				borderRadius: 0,
				padding: 0,
				minWidth: 'auto',
				border: 0,
				borderBottom: '1px solid',
				'&:hover': {
					borderColor: 'transparent',
					color: globalTheme.palette.grey.dark,
				},
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.medium,
				},
			},
			textWhite: {
				color: globalTheme.palette.common.white,
				'&:hover': {
					borderColor: 'transparent',
					color: globalTheme.palette.common.white,
				},
			},
			textLink: {
				borderRadius: 0,
				padding: 0,
				minWidth: 'auto',
				border: 0,
				textDecoration: 'underline',
				'&:hover': {
					textDecoration: 'underline',
				},
			},
			sizeSmall: {
				minWidth: 133,
				minHeight: 40,
				padding: '9px 20px',
				fontSize: globalTheme.typography.fontSize - 2,
			},
			sizeMedium: {
				'& .MuiButton-iconSizeMedium.MuiButton-startIcon': {
					'& .MuiSvgIcon-fontSizeSmall': {
						fontSize: muiTheme.typography.pxToRem(12),
					},
					'& .MuiSvgIcon-fontSizeMedium': {
						fontSize: muiTheme.typography.pxToRem(24),
					},
					'& .MuiSvgIcon-fontSizeLarge': {
						fontSize: muiTheme.typography.pxToRem(48),
					},
				},
			},
			sizeLarge: {
				minWidth: 203,
				minHeight: 80,
				padding: '18px 41px',
				fontSize: globalTheme.typography.fontSize + 4,
			},
			textSizeSmall: {
				borderRadius: 0,
				padding: 0,
				minWidth: 'auto',
				minHeight: 'auto',
				borderBottom: '1px solid',
				fontSize: globalTheme.typography.fontSize - 2,
			},
			textSizeLarge: {
				minWidth: 'auto',
				minHeight: 'auto',
				borderRadius: 0,
				padding: 0,
				fontSize: globalTheme.typography.fontSize + 4,
			},
			loading: {
				marginRight: globalTheme.spacing(2),
				color: 'inherit',
			},
			white: {
				backgroundColor: 'transparent',
				color: globalTheme.palette.common.white,
			},
			textNoLink: {
				border: 0,
				padding: 0,
				minWidth: 'auto',
				color: globalTheme.palette.primary.main,
				fontFamily: globalTheme.typography.fontFamily,
				fontWeight: 'normal',
				'& .MuiButton-startIcon': {
					marginRight: globalTheme.spacing(2),
					'&>*:nth-of-type(1)': {
						fontSize: muiTheme.typography.pxToRem(20),
					},
				},
				'&:hover': {
					color: globalTheme.palette.grey.dark,
				},
			},
			textNoLinkGrey: {
				color: globalTheme.palette.grey.medium,
				'& .MuiButton-startIcon': {
					color: globalTheme.palette.grey.medium,
				},
			},
			textNoLinkWhite: {
				color: globalTheme.palette.white.main,
				'& .MuiButton-startIcon': {
					color: globalTheme.palette.white.main,
				},
			},
		},
	},
	MuiButtonBase: {
		defaultProps: {
			disableRipple: true,
		},
	},
}

export default Button
